<template>
    <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
            <!-- Table Header -->
            <thead>
            <tr class="text-left font-bold">
                <th v-for="(header, index) in headers" :key="index" class="pb-4 pt-6 px-6">
                    {{ header }}
                </th>
            </tr>
            </thead>
            <tbody>
            <!-- Table Rows -->
            <template v-for="(row, rowIndex) in data" :key="'row-' + rowIndex">
                <tr
                    class="hover:bg-gray-100 focus-within:bg-gray-100"
                >
                    <td v-for="(cell, cellIndex) in row" :key="cellIndex" class="border-t px-6 py-4">
                        <a v-if="cell.isLinkAction" :href="cell.path + '' + cell.value + '/edit'">{{ cell.label }}</a>
                        <span v-else-if="!cell.isAction">{{ cell.value }}</span>
                        <span v-else>
                            <button @click="handleAction(cell, rowIndex)" :class="getButtonClass(cell.action)">
                              {{ cell.label }}
                            </button>
                        </span>
                    </td>
                </tr>
                <!-- Expandable Row -->
                <tr v-if="expandedRows.includes(rowIndex)" :key="'expanded-' + rowIndex">
                    <td :colspan="headers.length" class="border-t bg-gray-50">
                        <slot :rowIndex="rowIndex" :row="row"></slot>
                    </td>
                </tr>
<!--                <td v-for="(cell, cellIndex) in row" :key="cellIndex" class="border-t px-6 py-4">
                    <span v-if="!cell.isAction">{{ cell.value }}</span>
                    <span v-else>
                        <button @click="handleAction(cell.action, rowIndex, row)">
                            {{ cell.label }}
                        </button>
                </span>
                </td>-->

            </template>

            <!-- No Data Row -->
            <tr v-if="data.length === 0">
                <td class="px-6 py-4 border-t text-center" :colspan="headers.length">
                    No activity found.
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        headers: {
            type: Array,
            required: true,
        },
        data: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            expandedRows: [],
        };
    },
    methods: {
        handleAction(cell, rowIndex) {
            if (cell.action === 'toggleExpand') {
                if (this.expandedRows.includes(rowIndex)) {
                    this.expandedRows = this.expandedRows.filter((index) => index !== rowIndex);
                } else {
                    this.expandedRows.push(rowIndex);
                }
            }
            if (cell.action === 'edit') {
                // Redirect to the edit page with the item's ID
                const id = cell.value; // Assuming cell.value contains the ID
                const path = cell.path+`${id}/edit`
                window.location.href = path;
            }
            if (cell.action === 'pdfDownload') {
                this.$emit('pdfDownload',rowIndex);
            }
        },
        getButtonClass(action) {
            switch (action) {
                case 'pdfDownload':
                    return 'btn-sm btn-primary bg-blue-500 btn  px-4 py-2 rounded hover:bg-blue-600';
                case 'edit':
                    return 'bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600';
                case 'toggleExpand':
                    return 'bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600';
                default:
                    return 'bg-gray-300 text-black px-4 py-2 rounded';
            }
        },
    },
};
</script>
